module.exports = __webpack_public_path__ + "static/media/ic_selection_selected.21861cfb.svg";